export default __webpack_public_path__ + "static/world-of-good-7aa2bc140ac04a6cb4db92cdf06e3255.svg";